// businessProfileByIdSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessProfile } from '../services/businessService';

// Async thunk to fetch business profile by ID
export const fetchBusinessProfileById = createAsyncThunk(
  'businessProfileById/fetch',
  async (id, thunkAPI) => {
    try {
      const response = await getBusinessProfile(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const businessProfileByIdSlice = createSlice({
  name: 'businessProfileById',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearBusinessProfileById: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    updateBusinessProfileInSlice: (state, action) => {
      if (state.data) {
        state.data = { ...state.data, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessProfileById.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBusinessProfileById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchBusinessProfileById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearBusinessProfileById, updateBusinessProfileInSlice } = businessProfileByIdSlice.actions;
export default businessProfileByIdSlice.reducer;